import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PageHero from '../components/PageHero';
import './FAQPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// SVG icons as constants
const FILE_ICON = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="45" height="58" xml:space="preserve"><image id="image0" width="45" height="58" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAA6CAMAAAATFyCLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA0lBMVEWzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdGzvdH////H6SKNAAAARHRSTlMAhv7u84TwS4HL9X+WQX1De0b2eEf3dUj4c0n5cUxvTm1Qawt3Tce/aV/9BU8jIrO7UyszPjfmATxEWByiqhCAiF4HZh6jnWoAAAABYktHREWOs6hXAAAAB3RJTUUH4gsdEDsNHN6ejwAAAQFJREFUSMft1l1TgkAUgOHjllakaSVp4VdFVlYghIpAKnr+/2+KG8SdOcscL5hhmt5L5pmd5cwuA2B+FZBCcaLuFLEq6xqoO0tWPz9CX2h4ydf1hoZXfA1NDVt8Ddc3eMvX0Nbxjq+h08V7voYHA3t8DX0DB3wNQ0OM+BoeDfF0oJ8HZtpLpsf7h68o3jL9nh28ycdeSwly7c907S/zMB3z9y1X+wPasqd0tkVoR3nvHWon7jedW+6ZFKk9XTFA3SP0bK74dM5npX7LIvXCX9L5C0IHyhMbEDqMfuiisNQzKVKv1hu69YrQsXLeMaG38Y4u3pZ6Jv8603l/eHIi0cf0C0aSio9dfv0GAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTExLTI5VDIzOjU5OjEzLTA3OjAwH9KyhAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0xMS0yOVQyMzo1OToxMy0wNzowMG6PCjgAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC"/></svg>`;

const GEAR_ICON = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="54" height="54" xml:space="preserve"><image id="image0" width="54" height="54" x="0" y="0" href="data:image/png;base64,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"/></svg>`;

function FAQPage() {
  const [faqData, setFaqData] = useState(null);
  const [title, setTitle] = useState('FAQ');
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/pages/faq`);
        setTitle(response.data.title);

        // Parse JSON content
        if (response.data.content_type === 'faq_json') {
          const data = JSON.parse(response.data.content);
          setFaqData(data);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching FAQ page:', error);
        setLoading(false);
      }
    };

    fetchPageContent();
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const getIcon = (iconType) => {
    const icon = iconType === 'gear' ? GEAR_ICON : FILE_ICON;
    console.log('Getting icon for type:', iconType);
    console.log('Icon length:', icon.length);
    console.log('Icon preview:', icon.substring(0, 100));
    return icon;
  };

  if (loading) {
    return <div className="page-loading">Loading...</div>;
  }

  if (!faqData || !faqData.sections) {
    return <div className="page-loading">No FAQ data available</div>;
  }

  let questionIndex = 0;

  return (
    <div className="faq-page">
      <PageHero title={title.toUpperCase()} />

      <div className="faq-container">
        {faqData.sections.map((section, sectionIdx) => (
          <div key={sectionIdx} className="faq-section elementor-element">
            <div className="elementor-widget-container">
              <div style={{marginBottom: '7px'}}>
                <div className="elementor-image-box-sub-title">{section.subtitle}</div>
              </div>
              <div className="elementor-image-box-wrapper" style={{display: 'flex', alignItems: 'center'}}>
                <div className="elementor-image-framed" style={{flexShrink: 0}}>
                  <figure className="elementor-image-box-img" style={{margin: 0}}>
                    {section.icon === 'file' ? (
                      <img
                        src="/file-icon.png"
                        alt="File Icon"
                        width="45"
                        height="58"
                        style={{display: 'block'}}
                      />
                    ) : (
                      <img
                        src="/gear-icon.png"
                        alt="Gear Icon"
                        width="54"
                        height="54"
                        style={{display: 'block'}}
                      />
                    )}
                  </figure>
                </div>
                <div style={{flex: 1}}>
                  <h3 className="elementor-image-box-title">{section.title}</h3>
                </div>
              </div>
            </div>

            <div className="elementor-widget-container accordion-container">
              <div className="elementor-accordion" role="tablist">
              {section.questions.map((item) => {
                const currentIndex = questionIndex++;
                const isOpen = openIndex === currentIndex;
                return (
                  <div key={currentIndex} className="elementor-accordion-item">
                    <div
                      id={`elementor-tab-title-${currentIndex}`}
                      className={`elementor-tab-title ${isOpen ? 'elementor-active' : ''}`}
                      tabIndex={currentIndex}
                      data-tab={currentIndex}
                      role="tab"
                      aria-controls={`elementor-tab-content-${currentIndex}`}
                      onClick={() => toggleAccordion(currentIndex)}
                    >
                      <span className="elementor-accordion-icon" aria-hidden="true">
							<i className="elementor-accordion-icon-closed fa fa-plus-circle"></i>
							<i className="elementor-accordion-icon-opened fa fa-minus-circle"></i>
						</span>
                    {item.question}            </div>
                    <div
                      id={`elementor-tab-content-${currentIndex}`}
                      className={`elementor-tab-content elementor-clearfix ${isOpen ? 'elementor-active' : ''}`}
                      data-tab={currentIndex}
                      role="tabpanel"
                      aria-labelledby={`elementor-tab-title-${currentIndex}`}
                      style={{ display: isOpen ? 'block' : 'none' }}
                    >
                      <p>{item.answer}</p>
                    </div>
                  </div>
                );
              })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQPage;
